import { r as registerInstance, h } from './index-16dc7dde.js';

const headerCss = ".title-header{font-family:ArialRoundedMTforSE-Bold, sans-serif;font-weight:700;text-transform:none;font-size:25px;color:#000;letter-spacing:0;margin:0}.specifications-header{font-family:\"Arial Unicode MS\", Arial, sans-serif;text-transform:none;font-size:9px;color:#626469;letter-spacing:0;margin:5px 0}";

let ProductDatasheetHeader = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
  }
  render() {
    return (h("div", null, this.title ? h("h1", { class: "title-header" }, this.title) : null, this.subtitle ? h("p", { class: "specifications-header" }, this.subtitle) : null));
  }
};
ProductDatasheetHeader.style = headerCss;

export { ProductDatasheetHeader as pes_pdf_header };
